import React from 'react'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import ResumeDownload from 'components/ResumeDownload/ResumeDownload'
import {
  ActionMenu,
  ItemText,
  SmallButtons,
} from 'components/ActionStyles/ActionStyles'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, Dropdown } from 'antd'

const { confirm } = Modal

const StudentDetailsAction = ({
  deleteStudent,
  singleStudentData,
  subEvents,
}) => {
  let menuItems = [
    {
      key: 'resume',
      hidden: !subEvents?.includes('DOWNLOAD RESUME'),
      label: (
        <ResumeDownload
          triggerButton={<ItemText>Download Resume</ItemText>}
          studentData={singleStudentData}
        />
      ),
    },
    {
      key: 'remove',
      hidden: !subEvents?.includes('REMOVE CANDIDATE'),

      label: <ItemText>Remove Candidate</ItemText>,
      onClick: () => {
        showConfirm()
      },
    },
  ]?.filter(item => !item.hidden)
  const menu = <ActionMenu width={'165px'} items={menuItems} />

  const removeStudent = () => {
    deleteStudent()
  }

  const showConfirm = () => {
    confirm({
      title: 'Do you want to delete selected student?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        removeStudent()
      },
      onCancel() {},
      okText: 'Delete',
    })
  }

  return (
    <>
      {!!menuItems?.length && (
        <Dropdown overlay={menu} trigger={['click']}>
          <a onClick={e => e.preventDefault()} href="/">
            <SmallButtons height={'38px'} icon={<VerticalThreeDots />} />
          </a>
        </Dropdown>
      )}
    </>
  )
}

export default StudentDetailsAction
